var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('icon-svg',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"icon--sm ml-1",staticStyle:{"fill":"#074f7f !important"},attrs:{"icon":"helpCircle","title":_vm.text}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }